module.exports = __webpack_public_path__ + "img/0Q3B3739_FoamcoreMatted_MockedUp.c9d88a6b.jpg";